/* eslint-disable react/prop-types */
// Disabling propTypes for refactor of processor
import React from 'react';
import { Link } from 'react-router';
import classNames from 'classnames';
import Badge from 'components/Badge';
import { SHOW_STATE_UPCOMING } from 'helpers/BadgeHelper';
import { TileImage, TileTitle, Detail } from '../../components';
import Style from '../../Styles/SearchTile.module.scss';

const SearchTile = ({
  account,
  altText,
  badge,
  gridIndex,
  gridTitle,
  hoverImage,
  image,
  isDisabled,
  isHoverStateV2,
  isRedirect,
  isSeriesDetailAvailable,
  isUpcoming,
  itemIndex,
  link,
  name,
  network,
  onTileClick,
  onTitleClick,
  originalItem,
  percentWatched,
  recommendationIdData,
  startDate,
  subtitleText,
  target,
  theme,
  title,
  titleLines,
  titleLink,
  titleText,
}) => {
  const titleOptions = {
    account,
    gridIndex,
    gridTitle,
    isDisabled,
    isHoverStateV2,
    isRedirect,
    isSeriesDetailAvailable,
    isUpcoming,
    itemIndex,
    link: titleLink || link,
    name,
    network,
    onClick: onTileClick,
    onTitleClick,
    originalItem,
    percentWatched,
    recommendationIdData,
    Style,
    subtitleText,
    target,
    title,
    titleLines,
    titleText,
  };
  const shouldRenderBadge = badge !== SHOW_STATE_UPCOMING;

  return (
    <div className={theme.tile}>
      <Link
        aria-label={titleText}
        className={classNames([Style.imageContainer, Style.maintainRatioContainer])}
        onClick={onTileClick}
        to={link}
      >
        <TileImage image={image || hoverImage} altText={altText} rendered Style={Style} />
        {shouldRenderBadge && <Badge theme={Style} badge={badge} startDate={startDate} />}
      </Link>
      <Detail Style={Style}>
        <div className={Style.info}>
          <TileTitle {...titleOptions} />
        </div>
      </Detail>
    </div>
  );
};

export default SearchTile;
